import { c as _c } from "react/compiler-runtime";
import styles from "./DKMemberShipDisplay.module.scss";
import { Dkmembershipdisplay } from "../../../../studio/sanity.types";
import { useEffect, useState } from "react";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
import { useMainLocale } from "../../../../context/MainLocaleContext";
export const DKMembershipDisplay: React.FC<Pick<Dkmembershipdisplay, "membership_count_subtitle" | "description">> = t0 => {
  const $ = _c(18);
  const {
    membership_count_subtitle,
    description
  } = t0;
  const [memberships, setMemeberships] = useState(null);
  const isDanishSite = useMainLocale() === "dk";
  let t1;
  let t2;
  if ($[0] !== isDanishSite) {
    t1 = () => {
      if (!isDanishSite) {
        return;
      }
      fetch(`${process.env.NEXT_PUBLIC_EFFEKT_API}/api/kpi`).then(response => {
        if (response.ok) {
          response.json().then(data => {
            setMemeberships(data.kpi.members_confirmed + data.kpi.members_pending_renewal);
          });
        }
      }).catch(_temp);
    };
    t2 = [isDanishSite];
    $[0] = isDanishSite;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!isDanishSite) {
    return null;
  }
  const t3 = `${styles.number} ${memberships === null ? styles.loading : ""}`;
  let t4;
  if ($[3] !== memberships) {
    t4 = memberships ? Intl.NumberFormat("dk-DK").format(memberships) : <div className={styles.shimmer} />;
    $[3] = memberships;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== membership_count_subtitle) {
    t6 = <span className={styles.subtitle}>{membership_count_subtitle}</span>;
    $[8] = membership_count_subtitle;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className={styles.count}>{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = description as any;
  let t9;
  if ($[13] !== t8) {
    t9 = <div className={styles.description}><PortableText value={t8} components={customComponentRenderers} /></div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className={styles.container}>{t7}{t9}</div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
interface Kpi {
  dkk_total: number;
  dkk_total_ops: number;
  dkk_pending_transfer: number;
  dkk_last_30_days: number;
  dkk_recurring_next_year: number;
  members_confirmed: number;
  members_pending_renewal: number;
  monthly_donors: string; // Represented as string in JSON
  number_of_donors: number;
  is_max_tax_deduction_known: number; // Could be boolean if 0 or 1 are the only options
  oldest_stopped_donation_age: number;
  missing_gavebrev_income_proof: string; // Represented as string in JSON
  pending_skat_update: string; // Represented as string in JSON
}
interface ApiResponse {
  // There are more fields in the response, but we only need the kpi field for now
  kpi: Kpi;
}
function _temp(error) {
  console.error("Error fetching data:", error);
}